
var token = 'https://sso.mm-api.agency/oauth/token';

var sso = 'https://sso.mm-api.agency/';
var clients = 'https://clients.mm-api.agency/';
var crm = 'https://crm.mm-api.agency/';
var crm1 = 'https://crm.mm-api.agency/';
var calls = 'https://calls.mm-api.agency/';
var leadgen = 'https://leadgen.mm-api.agency/';
var promotions = 'https://promos.mm-api.agency/';
var blogs = 'https://blogs.mm-api.agency/';
var products = 'https://products.mm-api.agency/';
var sfn = 'https://sfn.mm-api.agency/';
var endpoints = products+'admin/sites';
var sfnEndpoints = sfn+'admin/sites';
var allCatalogs = products+'admin/catalog/options';
var allSfnCatalogs = 'https://sfn.mm-api.agency/admin/catalog/options';
var adwords = 'https://adwords-report.mm-api.agency/'

export const API_URLS = {
	API             	: clients,
	CRM 				: crm,
	CRM1 				: crm1,
	ENDPOINTS 			: endpoints,
	PRODUCTS 			: products,
	SFN					: sfn,
	SFNENDPOINTS 		: sfnEndpoints,
	ALLCATALOGS 		: allCatalogs,
	ALLSFNCATALOGS 		: allSfnCatalogs,
	
	listClients     	: clients+'list/all',
	addClientUrl    	: clients+'client',
	
	site            	: clients+'site/',
	siteCreate      	: '/create',

	contact				: clients+'contact/',
	postContact			: clients+'contact',

	location			: clients+'location/',
	postLocation		: clients+'location',

	credCreate			: clients+'credential',
	socialCreds			: '/credential/group/social',
	shawCreds			: '/credential/group/shaw',
	crmCreds			: '/credential/group/crm',
	serviceCreds		: '/credential/type/',
	sharpSpringCreate	: crm+'sharpspring/',

	listCatalogs		: '/catalog', //api/clientCode/siteCode/catalog
	rebuildCatalogs		: 'https://sfn.mm-api.agency/task/catalog/',

	tokenUrl        	: token,
	sso 				: sso,

}

export const DASHBOARD = {
	leads 				: crm+'report',
	calls 				: calls+'report',
	adwords 			: adwords,
}

export const FYW_URLS = {
	tokenUrl        	: token,

	API 				: leadgen,

	listRetailers		: leadgen+'fyw/retailers',
	retailer			: leadgen+'retailer/',
	location			: leadgen+'location/',
}

export const PROMO_URLS = {
	tokenUrl			: token,

	API 				: promotions,

	listAllPromotions	: promotions+'promos',
	promo 				: promotions+'promo/',
	widget				: promotions+'widget',
	image				: promotions+'image/',
	text				: promotions+'text/',
	widgetClient		: promotions+'widget/client',
	participating		: promotions+'promos/current/',
	template 			: crm+'templates'
}

export const BLOG_URLS = {
	tokenUrl			: token,

	API 				: blogs,
	blog 				: blogs+'blog/',
	image				: blogs+'image/',

}


// WEBPACK FOOTER //
// ./src/helpers/api/API_URLS.js